import { Button, OutlinedSelect, SelectOptionType } from '@octano/global-ui';
import { useCallback } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Col, Form, Row } from 'reactstrap';
import { TranslationsKeys } from '../../../../../locales/translations';
import { StudentObservationFiltersLoaderData } from '../Loaders/StudentObservationFiltersLoader';
import { StudentObservationsDataLoader } from '../Loaders/StudentObservationsLoader';

interface FiltersForm {
  year?: SelectOptionType | null;
  month?: SelectOptionType | null;
}

const StudentObservationsFilters = () => {
  const { t } = useTranslation(TranslationsKeys.STUDENT_FILE_OBSERVATIONS);
  const data = StudentObservationFiltersLoaderData();
  const { query, updateQuery } = StudentObservationsDataLoader();

  const methods = useForm<FiltersForm>({
    mode: 'onSubmit',
    defaultValues: {
      year: null,
      month: null,
    },
  });
  const {
    reset,

    formState: { isSubmitting },
    handleSubmit,
    control,
  } = methods;

  const handleSearch = useCallback(
    (values: FiltersForm) => {
      updateQuery({
        ...query,
        year: values.year?.value ? +values.year.value : undefined,
        month: values.month?.value ? +values.month.value : undefined,
        page: 1,
      });
    },
    [query, updateQuery],
  );

  const handleClear = useCallback(() => {
    reset({
      year: null,
      month: null,
    });

    updateQuery({
      ...query,
      year: undefined,
      month: undefined,
      page: 1,
    });
  }, [reset, updateQuery, query]);
  return (
    <Form onSubmit={handleSubmit(handleSearch)}>
      <Row className="pb-4 pt-4 gutters-filters">
        <Col xs={12} md={3}>
          <OutlinedSelect
            control={control}
            name="year"
            options={data.years}
            label={t('list.filters.year.label')}
            placeholder={t('list.filters.year.placeholder')}
            isClearable={false}
            disabled={!data.years.length}
          />
        </Col>

        <Col xs={12} md={3}>
          <OutlinedSelect
            control={control}
            name="month"
            options={data.months}
            label={t('list.filters.month.label')}
            placeholder={t('list.filters.month.placeholder')}
            isClearable={false}
            disabled={!data.months.length}
          />
        </Col>

        <Col xs={12} md={6} className="mt-4">
          <div className="d-flex justify-content-end">
            <Button
              text={t('common:actions.search')}
              size="md"
              type="submit"
              loading={isSubmitting}
            />
            <Button
              text={t('common:actions.clean')}
              className="ml-2"
              size="md"
              outlined
              type="button"
              onClick={handleClear}
            />
          </div>
        </Col>
      </Row>
    </Form>
  );
};

export default StudentObservationsFilters;
